import { TextButton } from "@clipboard-health/ui-components";
import { Link } from "react-router-dom";

import { useOpenGeoLocationContext } from "../../OpenGeoLocation/useOpenGeoLocation";

export function PlacementViewOnMap() {
  const { href, onClick } = useOpenGeoLocationContext();

  return (
    <TextButton
      href={href}
      LinkComponent={Link}
      onClick={(event) => {
        event.stopPropagation();
        if (onClick) {
          onClick();
        } else {
          window.open(href, "_blank");
        }
      }}
    >
      View on map
    </TextButton>
  );
}
